<template>
  <settings-modal
    class="deposit-rates-editor-modal t-deposit-rates-editor-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >{{ title }}</span>

    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="form.rate3"
          class="pt-0"
          type="number"
          label="3 months"
          :error-messages="getValidationErrorMessage('rate3')"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="form.rate6"
          type="number"
          label="6 months"
          :error-messages="getValidationErrorMessage('rate6')"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="form.rate12"
          type="number"
          label="12 months"
          :error-messages="getValidationErrorMessage('rate12')"
        />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs6>
        <v-text-field
          v-model="form.rate24"
          type="number"
          label="24 months"
          :error-messages="getValidationErrorMessage('rate24')"
        />
      </v-flex>
    </v-layout>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >{{ confirmButtonText }}</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  // Events
  import { EVENT_DEPOSIT_RATES_CHANGE } from '@/events/deposits'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import DepositApi from '@/services/Api/DepositApi'

  // Mixins
  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'DepositRatesEditorModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        form: {
          rate3: null,
          rate6: null,
          rate12: null,
          rate24: null
        },
        saveDepositRatesApiRequest: new ApiRequest(DepositApi.saveRates)
      }
    },
    computed: {
      hasDepositRates () {
        return this.modalData.depositRates != null
      },
      title () {
        return `${this.hasDepositRates ? `Edit ${this.currency}` : 'Add'} rates`
      },
      confirmButtonText () {
        return this.hasDepositRates ? 'save changes' : 'add rates'
      },
      error () {
        return this.saveDepositRatesApiRequest.error
      },
      loading () {
        return this.saveDepositRatesApiRequest.loading
      },
      requiredFields () {
        return Object.keys(this.form)
      },
      currency () {
        return this.modalData.depositRates.currency
      },
      rates () {
        const { currency, ...rates } = this.modalData.depositRates

        return rates
      }
    },
    created () {
      if (this.hasDepositRates) {
        this.setFormData(this.rates)
      }
    },
    methods: {
      onConfirmButtonClick () {
        this.saveDepositRatesApiRequest
          .execute({
            currency: this.currency,
            ...this.parsedFormInput
          })
          .then(() => {
            this.$eventHub.$emit(EVENT_DEPOSIT_RATES_CHANGE)

            this.showSuccessFlashMessage(
              this.hasDepositRates
                ? 'Rates have been successfully edited.'
                : 'Rates have been successfully added.'
            )
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
